const parseKey = (key: string) => {
	const pattern = /\(:([^)]+)\)/gi
	const args: string[] = []

	let match: RegExpExecArray | null
	let regex = key

	// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
	while ((match = pattern.exec(key)) !== null) {
		regex = regex.replace(match[0], '([^.]+)')
		args.push(match[1])
	}

	if (regex === key) {
		return null
	}

	return { args, regex: new RegExp(regex) }
}

const parseArgs = ({ args, regex, key }) => {
	const values = regex.exec(key)

	values.shift()

	// biome-ignore lint/performance/noAccumulatingSpread: <explanation>
	return values.reduce((res, m, i) => ({ ...res, [args[i]]: m }), {})
}

interface PlainItem {
	fn(...args: unknown[]): any
}

interface RegexItem extends PlainItem {
	regex: RegExp
	args?: string[]
}

type Adapter = { key: string } & (PlainItem | RegexItem)

export class Store {
	plain: Record<string, PlainItem>
	regex: RegexItem[]
	parent?: Store

	constructor(adapters, parent?: Store) {
		this.plain = {}
		this.regex = []
		this.parent = parent

		this.register(adapters)
	}

	setParent(parent?: Store) {
		if (this.parent && this.parent !== parent) {
			throw new Error("can't override parent")
		}

		this.parent = parent
	}

	register(adapters: Adapter[]) {
		// biome-ignore lint/complexity/noForEach: <explanation>
		adapters.forEach((a) => {
			const parsed = parseKey(a.key)
			const registration = {
				fn: a.fn,
			}

			if (!parsed) {
				this.plain[a.key] = registration
				return
			}

			this.regex.push({
				...registration,
				regex: parsed.regex,
				args: parsed.args,
			})
		})
	}

	get = (key: string) => {
		if (!key) {
			return null
		}

		if (this.plain[key]) {
			return this.plain[key].fn()
		}

		const adapter = this.regex.find((s) => s.regex.test(key))

		if (!adapter) {
			return this.parent ? this.parent.get(key) : null
		}

		return adapter.fn(
			parseArgs({ args: adapter.args, regex: adapter.regex, key }),
		)
	}
}
